var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompassAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM15.9455 13.6679L16.962 9.05826C17.2208 7.88432 16.1157 6.77916 14.9417 7.03804L10.3321 8.05455C10.0173 8.12396 9.72307 8.24012 9.45648 8.39582L15.6042 14.5435C15.7599 14.2769 15.876 13.9827 15.9455 13.6679ZM14.5435 15.6042L8.39582 9.45648C8.24012 9.72307 8.12396 10.0173 8.05455 10.3321L7.03804 14.9417C6.77916 16.1157 7.88432 17.2208 9.05826 16.962L13.6679 15.9455C13.9827 15.876 14.2769 15.7599 14.5435 15.6042Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassAlt1);
export default __webpack_public_path__ + "static/media/compass-alt-1.2388a4835cbbd447f2cb36a4aad8882c.svg";
export { ForwardRef as ReactComponent };